import { render, staticRenderFns } from "./NavCategoryNode.vue?vue&type=template&id=3ae83f58&scoped=true"
import script from "./NavCategoryNode.vue?vue&type=script&lang=js"
export * from "./NavCategoryNode.vue?vue&type=script&lang=js"
import style0 from "./NavCategoryNode.vue?vue&type=style&index=0&id=3ae83f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae83f58",
  null
  
)

export default component.exports